import React from "react";
import { useState, useEffect } from "react";
import {
  Container,
  Box,
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import Logocolor from "../../../Image/Logo.png";
import { TituloPrincipal, InputBuscador, buttonGuardar, Texto, TextoTablaIngresoEgreso } from "../../../Layouts/CustomStyles";
import { useGetFlujoCajaRME } from "../../../Services/FlujodeCaja";
import { HandleExportarFlujodeCaja } from "../../../Components/FuncionesGenerales/excel/FlujodeCajaExcel";
import DownloadIcon from "@mui/icons-material/Download";
import { formatPercent } from "../../../Components/FuncionesGenerales/FormatoPorcentaje";

export const PaginaFlujoIngresoRME = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const { flujocaja, loadingFlujoCaja, exportarFlujoCaja } = useGetFlujoCajaRME(fechaInicio, fechaFin);
  const [periodosVisibles, setPeriodosVisibles] = useState([]);
const [periodosSeleccionados, setPeriodosSeleccionados] = useState([]);
  // 🔹 Formato CLP
  const formatoCLP = (monto) =>
    `$${parseInt(monto).toLocaleString("es-CL", { minimumFractionDigits: 0 })}`;

  const periodos = flujocaja?.periodos || [];

  // 🔹 Calcular los 3 últimos períodos al inicio
useEffect(() => {
  if (!flujocaja?.periodos) return;

  const periodosOrdenados = [...flujocaja.periodos].reverse();

  let visibles = [];

  if (!fechaInicio && !fechaFin) {
    visibles = periodosOrdenados.slice(0, 3);
  } else {
    const filtrados = periodosOrdenados.filter((p) => {
      const fechaPeriodo = new Date(p.mes);
      const desde = fechaInicio ? new Date(fechaInicio) : null;
      const hasta = fechaFin ? new Date(fechaFin) : null;

      if (desde && hasta)
        return fechaPeriodo >= desde && fechaPeriodo <= hasta;

      if (desde)
        return fechaPeriodo >= desde;

      if (hasta)
        return fechaPeriodo <= hasta;

      return true;
    });

    visibles = filtrados.slice(0, 3);
  }

  visibles = visibles.reverse();

  setPeriodosVisibles(visibles);

  // <-- ESTO ES LO IMPORTANTE
  setPeriodosSeleccionados(
    visibles.map((p) => p.fecha || p.mes)
  );

}, [flujocaja, fechaInicio, fechaFin]);
 
  const periodosHasta = fechaInicio
    ? periodos.filter((p) => new Date(p.mes) > new Date(fechaInicio))
    : periodos.slice(1);

 
const tiposIngresos = Array.from(
  new Set(
    periodosVisibles.flatMap((p) =>
      Object.entries(p.detalle.entradas || {})
        .filter(([cat, obj]) => Array.isArray(obj.items) && obj.items.length > 0)
        .map(([cat]) => cat)
    )
  )
);

const tiposIngresosFinanciamiento = Array.from(
  new Set(
    periodosVisibles.flatMap((p) =>
      Object.entries(p.detalle.entrada_financiamiento || {})
        .filter(([cat, obj]) => Array.isArray(obj.items) && obj.items.length > 0)
        .map(([cat]) => cat)
    )
  )
);

const ordenTipos = [
  "COSTO_OPERACIONAL",
  "OPERACIONAL",
  "ADMINISTRATIVO"
];

const tiposSalidas = Array.from(
  new Set(
    periodosVisibles.flatMap(p =>
      Object.keys(p.detalle?.salidas?.tipos || {})
    )
  )
).sort((a, b) => {
  const indexA = ordenTipos.indexOf(a);
  const indexB = ordenTipos.indexOf(b);

  if (indexA === -1) return 1;
  if (indexB === -1) return -1;

  return indexA - indexB;
});

const nombresTipos = {
  COSTO_OPERACIONAL: "Costo Operacional",
  OPERACIONAL: "Operacional",
  ADMINISTRATIVO: "Administrativo"
};

const categoriasSalidasInversion = Array.from(
  new Set(
    periodosVisibles.flatMap(p =>
      Object.keys(p.detalle?.salidas_inversiones?.categorias || {})
    )
  )
);


const TiposGastosFinancieros = Array.from(
  new Set(
    periodosVisibles.flatMap(p =>
      Object.keys(p.detalle?.gastos_financieros?.categorias || {})
    )
  )
);

const TiposGastosFinanciamiento = Array.from(
  new Set(
    periodosVisibles.flatMap(p =>
      Object.keys(p.detalle?.salidas_financiamiento?.categorias || {})
    )
  )
);


  const [open, setOpen] = useState(false);
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);

const handleOpenDetalle = (items, tipo, total ) => {

  setDetalleSeleccionado({
    tipo: tipo,
    items: items,
     total: total
  });

  setOpen(true);
};

  const handleClose = () => setOpen(false);

  
  if (loadingFlujoCaja) {
    return (
         <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "300px",
              gap: 2,
              position: "relative"
            }}
          >
          
            <CircularProgress size={90} thickness={4} sx={{ color: '#6fd385ff' }} />

            <Box
              component="img"
              src={Logocolor}
              alt="Logo"
              sx={{
                width: "55px",
                height: "55px",
                position: "absolute",
                top: "90px"
              }}
            />

            <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
              Cargando...
            </Typography>
          </Box>
    );
  }
  return (
    <Container maxWidth="xl">
      <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: "16px",
          backgroundColor: "#fafafa",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          fontFamily: "Poppins",
        }}
      >
        {/* Encabezado */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box display="flex" alignItems="center" gap={2}>
            <img src={Logocolor} alt="Logo CBO" style={{ width: 55, height: 55 }} />
            <Typography variant="h5" sx={TituloPrincipal}>
              Flujo de Caja RME
            </Typography>
          </Box>


          {/* Filtros */}
          <Box display="flex" justifyContent="flex-end" gap={2} mb={3}>
            <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
              <InputLabel id="select-periodo-desde">Desde</InputLabel>
              <Select
                labelId="select-periodo-desde"
                value={fechaInicio}
                label="Desde"
                onChange={(e) => setFechaInicio(e.target.value)}
              >
                {periodos.map((p, idx) => (
                  <MenuItem key={idx} value={p.mes}>
                    {new Date(p.mes + "-01").toLocaleDateString("es-CL", {
      year: "numeric",
      month: "long"
    })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
              <InputLabel id="select-periodo-hasta">Hasta</InputLabel>
              <Select
                labelId="select-periodo-hasta"
                value={fechaFin}
                label="Hasta"
                onChange={(e) => setFechaFin(e.target.value)}
              >
                {periodosHasta.map((p, idx) => (
                  <MenuItem key={idx} value={p.mes}>
                     {new Date(p.mes + "-01").toLocaleDateString("es-CL", {
      year: "numeric",
      month: "long"
    })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              sx={{
                color: '#fff',
                padding: '5px 20px',
                backgroundColor: "#2a8d74",
                borderRadius: "50px",
                textTransform: "none",
                fontFamily: "Poppins",
              }}
              onClick={() => {
                setFechaInicio("");
                setFechaFin("");
              }}
            >
              Limpiar
            </Button>
          </Box>
        </Box>
        <Box sx={{mb:2}}>
<Button
  sx={{
    color: "#fff",
    padding: "5px 20px",
    backgroundColor: "#2a8d74",
    borderRadius: "50px",
    textTransform: "none",
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    gap: 1,
  }}
   onClick={() => exportarFlujoCaja(periodosSeleccionados)}
  
>
  <DownloadIcon sx={{ fontSize: 20 }} />
  Descargar Flujo de Caja
</Button>

        </Box>

    
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#2a8d74b6" }}>
              <TableRow>
                <TableCell sx={{...TextoTablaIngresoEgreso, fontWeight: 600, color:"#fff" }}>Periodos</TableCell>
                 {periodosVisibles.map((p, index) => (
                  <TableCell key={index} align="center" sx={{...TextoTablaIngresoEgreso, fontWeight: 600, color:"#fff" }}>
                   {new Date(p.mes).toLocaleDateString("es-CL", {
  year: "numeric",
  month: "long",
}).replace(/^./, (str) => str.toUpperCase())}
                  </TableCell>
                ))} 
              </TableRow>
            </TableHead>

         <TableBody>

  
  {periodosVisibles.length === 0 && (
    <TableRow>
      <TableCell
        colSpan={1 + periodosVisibles.length}
        align="center"
        sx={{ py: 4, fontSize: "1rem", color: "#777" }}
      >
        No se encuentran registros
      </TableCell>
    </TableRow>
  )}


  {periodosVisibles.length > 0 && (
    <>
     <TableRow sx={{ backgroundColor: "#bceaffa8" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Saldo Inicial de caja
        </TableCell>
        
     {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.saldo_inicial)
            )}
          </TableCell>
        ))}
      </TableRow>

      {/* Flujo Neto */}
      <TableRow sx={{ backgroundColor: "#ffffff" }}>
        <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, color:'#15790c', fontWeight: 600 }}>
         Entrada de efectivo
        </TableCell>
     
      </TableRow>

      {/* Total Ingresos */}
      <TableRow sx={{ backgroundColor: "#bcffd6a8" }}>
        <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Ingresos Operacionales
        </TableCell>
        
      </TableRow> 

    
{tiposIngresos.map((categoria, idx) => (
  <TableRow key={`ingreso-${idx}`}>
    
    <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
      {categoria || "Otros"}
    </TableCell>

    {periodosVisibles.map((p, i) => {

      const categoriaObj = p.detalle.entradas?.[categoria];

      return (
        <Tooltip
          key={i}
          arrow
          title={
            categoriaObj?.items?.length ? (
              <div>
                {categoriaObj.items.map((item, index) => (
                  <div key={index}>
                    ver detalle
                  </div>
                ))}
              </div>
            ) : "Sin detalle"
          }
        >
          <TableCell
            align="center"
            sx={{
              ...TextoTablaIngresoEgreso,
              color: "#0d6840",
              fontWeight:600,
              cursor: categoriaObj?.items?.length ? "pointer" : "default",
            }}
            onClick={() => {
              if (categoriaObj?.items?.length > 0) {
                 handleOpenDetalle(categoriaObj.items, categoria,  categoriaObj.total_categoria);
              }
            }}
          >
            {categoriaObj ? formatoCLP(categoriaObj.total_categoria) : "-"}
          </TableCell>
        </Tooltip>
      );

    })}
  </TableRow>
))}

<TableRow sx={{ backgroundColor: "#bcffd6a8"}}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
         Total Ingresos Operacionales
        </TableCell>
         {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.total_ingresos)
            )}
          </TableCell>
        ))}
      </TableRow> 
<TableRow >
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Entrada de financiamiento
        </TableCell>
       {periodosVisibles.map((p, i) => {

    const totalFinanciamiento = Object.values(
      p.detalle?.entrada_financiamiento || {}
    ).reduce((acc, cat) => acc + (cat.total_categoria || 0), 0);

    return (
      <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
        {loadingFlujoCaja ? (
          <CircularProgress size={20} />
        ) : (
          formatoCLP(totalFinanciamiento)
        )}
      </TableCell>
    );
  })}
      </TableRow> 
      {tiposIngresosFinanciamiento.map((categoria, idx) => (
  <TableRow key={`ingreso-${idx}`}>
    {/* Nombre de la categoría */}
    <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
      {categoria || "Otros"}
    </TableCell>

    {/* Montos por cada periodo */}
    {periodosVisibles.map((p, i) => {
      // Obtener la categoría dentro de entradas
      const categoriaObj = p.detalle.entrada_financiamiento?.[categoria];

      return (
        <Tooltip key={i} title="Ver detalle del monto" arrow>
          <TableCell
            align="center"
            sx={{
              ...TextoTablaIngresoEgreso,
              color: "#19c87c",
              cursor: categoriaObj?.items?.length ? "pointer" : "default",
            }}
            onClick={() => {
              if (categoriaObj?.items?.length > 0) {
                 handleOpenDetalle(categoriaObj.items, categoria,  categoriaObj.total_categoria);
              }
            }}
          >
            {categoriaObj ? formatoCLP(categoriaObj.total_categoria) : "-"}
          </TableCell>
        </Tooltip>
      );
    })}
  </TableRow>
))}
      


<TableRow sx={{ backgroundColor: "#bcffd6a8"}}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Total entradas
        </TableCell>
       {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.total_entradas)
            )}
          </TableCell>
        ))}
      </TableRow> 
  <TableRow >
        <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
         Salidas de efectivo
        </TableCell>
     
      </TableRow>
      {/* Total Egresos */}
      <TableRow sx={{ backgroundColor: "#FFF3E0" }}>
  <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
    Salidas Operacionales
  </TableCell>

  
  
 
</TableRow>

   {tiposSalidas.map((tipo, idxTipo) => {

  const categorias = [
    ...new Set(
      periodosVisibles.flatMap(p =>
        Object.keys(p.detalle?.salidas?.tipos?.[tipo]?.categorias || {})
      )
    )
  ];
  

  return (
    <React.Fragment key={idxTipo}>

      <TableRow sx={{ backgroundColor: "#FFF3E0" }}>
        <TableCell sx={{...TextoTablaIngresoEgreso, fontWeight: 700 }}>
         {nombresTipos[tipo] || tipo}
        </TableCell>

        {periodosVisibles.map((p, i) => (
          <TableCell key={i}  align="center"
      sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
            {formatoCLP(
              p.detalle?.salidas?.tipos?.[tipo]?.total_tipo || 0
            )}
          </TableCell>
        ))}
      </TableRow>

      {categorias.map((categoria, idxCat) => (
        <TableRow key={`${idxTipo}-${idxCat}`}>
          <TableCell sx={{ pl: 4, ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
            {categoria}
          </TableCell>

          {periodosVisibles.map((p, i) => {

            const categoriaObj =
              p.detalle?.salidas?.tipos?.[tipo]?.categorias?.[categoria];

            return (
               <Tooltip key={i} title="Ver detalle del monto" arrow>
              <TableCell key={i}  align="center"
      sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500, cursor:'pointer' }}
       onClick={() => {
              if (categoriaObj?.items?.length > 0) {
                 handleOpenDetalle(categoriaObj.items, categoria,  categoriaObj.total_categoria);
              }
            }}>
                {categoriaObj
                  ? formatoCLP(categoriaObj.total_categoria)
                  : "-"}
              </TableCell>
              </Tooltip>
            );
          })}
        </TableRow>
      ))}

    </React.Fragment>
  );
})}

 <TableRow sx={{ backgroundColor:  "#FFF3E0" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Total salidas operacionales
        </TableCell>
     {periodosVisibles.map((p, i) => (
    <TableCell key={i} align="center"
      sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
      {formatoCLP(
        p.detalle?.salidas?.total || 0
      )}
    </TableCell>
  ))}
      </TableRow> 
    
     
      <TableRow sx={{ backgroundColor: "#FFF3E0"  }}>
  <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
    Gastos Financieros
  </TableCell>

</TableRow>
{TiposGastosFinancieros.map((categoria, idxCat) => (
  <React.Fragment key={idxCat}>

  

    {/* CATEGORIAS */}
    <TableRow>
      <TableCell
        sx={{ pl: 4, ...TextoTablaIngresoEgreso, fontWeight: 500 }}
      >
        {categoria}
      </TableCell>

      {periodosVisibles.map((p, i) => {

        const categoriaObj =
          p.detalle?.gastos_financieros?.categorias?.[categoria];

        return (
            <Tooltip key={i} title="Ver detalle del monto" arrow>
          <TableCell
            key={i}
            align="center"
            sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500, cursor:'pointer' }}
             onClick={() => {
              if (categoriaObj?.items?.length > 0) {
                 handleOpenDetalle(categoriaObj.items, categoria, categoriaObj.total_categoria);
              }
            }}
          >
            {categoriaObj
              ? formatoCLP(categoriaObj.total_categoria)
              : "-"}
          </TableCell>
          </Tooltip>
        );
      })}
    </TableRow>

  </React.Fragment>
))}

<TableRow sx={{ backgroundColor: "#FFF3E0" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Total gasto financiamientos
        </TableCell>
         {periodosVisibles.map((p, i) => (
    <TableCell 
    key={i} 
    align="center" 
    sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }} 
   >

      {formatoCLP(
        p.detalle?.gastos_financieros?.total_tipo || 0
      )}
    </TableCell>
  ))}
        </TableRow>

 <TableRow sx={{ backgroundColor:  "#FFF3E0" }}>
        <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Financiamientos / pago deuda
        </TableCell>
      
      </TableRow> 
{TiposGastosFinanciamiento.map((categoria, idxCat) => (
  <React.Fragment key={idxCat}>

  

    {/* CATEGORIAS */}
    <TableRow>
      <TableCell
        sx={{ pl: 4, ...TextoTablaIngresoEgreso, fontWeight: 500 }}
      >
        {categoria}
      </TableCell>

      {periodosVisibles.map((p, i) => {

        const categoriaObj =
          p.detalle?.salidas_financiamiento?.categorias?.[categoria];

        return (
           <Tooltip key={i} title="Ver detalle del monto" arrow>
          <TableCell
            key={i}
            align="center"
            sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500, cursor:'pointer' }}
             onClick={() => {
              if (categoriaObj?.items?.length > 0) {
                 handleOpenDetalle(categoriaObj.items, categoria, categoriaObj.total_categoria);
              }
            }}
          >
            {categoriaObj
              ? formatoCLP(categoriaObj.total_categoria)
              : "-"}
          </TableCell>
          </Tooltip>
        );
      })}
    </TableRow>

  </React.Fragment>
))}

    <TableRow sx={{ backgroundColor:  "#FFF3E0"  }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Total salidas financiamientos
        </TableCell>
       {periodosVisibles.map((p, i) => (
    <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
      {formatoCLP(
        p.detalle?.salidas_financiamiento?.total_tipo || 0
      )}
    </TableCell>
  ))}
      </TableRow> 
        
      <TableRow sx={{ backgroundColor:  "#FFF3E0"   }}>
        <TableCell colSpan={4} sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Inversión
        </TableCell>
      </TableRow> 
      
{categoriasSalidasInversion.map((categoria, idxCat) => (

  <TableRow key={idxCat}>
    <TableCell
      sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500, pl: 4 }}
    >
      {categoria}
    </TableCell>

    {periodosVisibles.map((p, i) => {

      const categoriaObj =
        p.detalle?.salidas_inversiones?.categorias?.[categoria];

      return (
        <Tooltip key={i} title="Ver detalle del monto" arrow>
        <TableCell
          key={i}
          align="center"
          sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 , cursor:'pointer' }}
           onClick={() => {
              if (categoriaObj?.items?.length > 0) {
                 handleOpenDetalle(categoriaObj.items, categoria, categoriaObj.total_categoria );
              }
            }}
        >
          {categoriaObj
            ? formatoCLP(categoriaObj.total_categoria)
            : "-"}
        </TableCell>
        </Tooltip>
      );
    })}

  </TableRow>

))}

      <TableRow sx={{ backgroundColor:  "#FFF3E0"  }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Total inversión
        </TableCell>
          {periodosVisibles.map((p, i) => (
    <TableCell
      key={i}
      align="center"
      sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}
    >
      {loadingFlujoCaja ? (
        <CircularProgress size={20} />
      ) : (
        formatoCLP(
          p.detalle?.salidas_inversiones?.total_general|| 0
        )
      )}
    </TableCell>
  ))}
      </TableRow> 
      
      <TableRow sx={{ backgroundColor:  "#FFF3E0"  }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Total salidas
        </TableCell>
       {periodosVisibles.map((p, i) => (
    <TableCell
      key={i}
      align="center"
      sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}
    >
      {loadingFlujoCaja ? (
        <CircularProgress size={20} />
      ) : (
        formatoCLP(
          p.total_salidas|| 0
        )
      )}
    </TableCell>
  ))}

           </TableRow> 
      <TableRow sx={{ backgroundColor: "#bceaffa8"  }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
          Flujo neto del mes
        </TableCell>
       {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 700 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.flujo_neto)
            )}
          </TableCell>
        ))}
      </TableRow> 
      <TableRow sx={{ backgroundColor: "#bceaffa8" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Saldo final de caja
        </TableCell>
      {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.saldo_final)
            )}
          </TableCell>
        ))}
      </TableRow> 
        <TableRow sx={{ backgroundColor: "#e4f7ad6c" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Margen de caja
        </TableCell>
         {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatPercent(p.margen_caja)
            )}
          </TableCell>
        ))}
      </TableRow> 
 

    </>
  )}
 
      
      
      

</TableBody>

          </Table>
        </TableContainer>

        {/* Dialog Detalle */}
 <Dialog
  open={open}
  onClose={handleClose}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 5,
      padding: 2,
    },
  }}
>
  <DialogTitle sx={{ ...Texto, fontWeight: 600 }}>
    Detalle  {detalleSeleccionado?.tipo}
  </DialogTitle>

  <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    
     <TableContainer>
    <Table>

      <TableHead>
        <TableRow>
          <TableCell><b>Descripción</b></TableCell>
           <TableCell><b>Sucursal</b></TableCell>
          <TableCell><b>Estado</b></TableCell> 
          <TableCell><b>Fecha</b></TableCell>
          <TableCell align="right"><b>Monto</b></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>

        {detalleSeleccionado?.items?.map((item, index) => (
          <TableRow key={index}>

            <TableCell>
              {item.concept  || item.description || "Sin descripción"}
            </TableCell>
             <TableCell>
              {item.sucursal || "-"}
            </TableCell>
            <TableCell>
              {item.estado || "-"}
            </TableCell>
            

            <TableCell>
              {item.fecha
    ? new Date(item.fecha + "T00:00:00").toLocaleDateString("es-CL")
    : "-"}
            </TableCell>

            <TableCell align="right">
              {formatoCLP(item.monto)}
            </TableCell>

          </TableRow>
        ))}

        {/* TOTAL */}
        <TableRow>
          <TableCell colSpan={4} align="right">
            <b>Total categoría</b>
          </TableCell>

          <TableCell align="right">
            <b>
              {formatoCLP(
                detalleSeleccionado?.total
              )}
            </b>
          </TableCell>
        </TableRow>

      </TableBody>

    </Table>
  </TableContainer>

  </DialogContent>

  <DialogActions>
    <Button onClick={handleClose} sx={buttonGuardar}>
      Cerrar
    </Button>
  </DialogActions>
</Dialog> 


      </Paper>
    </Container>
  );
};
